import { useEffect, useState, useRef } from "react";
import { Dropdown, Button, Form, Image } from "react-bootstrap";
import { Search, ThreeDotsVertical, XLg } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchLocationList } from "../../../store/actions/locationsAction";
import TableDesign from "../../common/table/TableDesign";
import DeleteLocationPopup from "./DeleteLocationPopup";
import ManageLocation from "./ManageLocation";
import ManageWorkForce from "../workforce/ManageWorkForce";
import ProfileImage from "../../../assets/images/profile.svg";
import { resetPopup } from "../../../store/reducerSlice/locations";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import Loader from "../../common/loader/Loader";
// import WorkForceListPage from "../workforce/WorkForceListPage";

const tableHeadings = [
  {
    label: "S.No.",
    width: "120px",
  },

  {
    label: "Title",
  },
  {
    label: "To Email",
  },
  {
    label: "CC Email",
  },
  {
    label: "Date",
  },
  {
    label: "Action",
    width: "120px",
  },
];

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const LocationList = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [selectLocation, setSelectLocation] = useState(null);
  const [selectWorkforce, setSelectWorkforce] = useState(null);
  const [workForceLinkModalShow, setWorkForceLinkModalShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filterOption, setFilterOption] = useState({
    orderBy: "createdAt",
    orderIn: -1,
  });
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [deleteRec, setDeleteRec] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {
    locations,
    filtered,
    pagination,
    isLoader,
    isRecordAdded,
    isRecordUpdated,
    error: apiError,
  } = useSelector((state) => {
    return state.locations;
  });

  const page = pagination?.currentPage;

  const cc = filtered || locations;

  useEffect(() => {
    dispatch(fetchLocationList(filterOption));
  }, [filterOption, isRecordUpdated]);

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };
  const formatedDate = (val) => {
    var options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(val).toLocaleDateString("nl-NL", options);
  };

  const hideHandle = () => {
    setModalShow(false);
    setSelectLocation(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
  };

  const createUpdateLocation = (location) => {
    dispatch(resetPopup());
    setModalShow(true);
    setSelectLocation(location);
    setTitle("Update Geography");
    setMessage("Geography updated successfully!");
    setShowResult(true);
  };

  const addNewLocation = () => {
    dispatch(resetPopup());
    setModalShow(true);
    setSelectLocation(null);
    setTitle("Add Geography");
    setMessage("Geography has been added successfully.");
    setShowResult(true);
  };

  const deleteEventHandler = (rec) => {
    dispatch(resetPopup());
    setDeleteRec(rec?._id);
    setDeleteModalShow(true);
    setTitle("Delete Geography");
    setMessage("Geography deleted successfully!");
    setShowResult(true);
  };

  const hideHandlerRes = () => {
    dispatch(resetPopup());
    setTitle(null);
    setMessage(null);
    setShowResult(false);
  };
  const hideHandleWorkforce = () => {
    setModalShow1(false);
    setSelectWorkforce();
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setWorkForceLinkModalShow(false);
  };
  const createUpdateWorkforce = (val) => {
    dispatch(resetPopup());
    setModalShow1(true);
    setSelectLocation(val.name);
    setSelectWorkforce(null);
    setTitle("Update Workforce");
    setMessage("Workforce updated successfully!");
    setShowResult(true);
  };
  return (
    <>
      <div className="container">
        <ManageWorkForce
          show={modalShow1}
          onHide={hideHandleWorkforce}
          title={selectWorkforce ? "Edit WorkForce" : "Add WorkForce"}
          selectWorkforce={selectWorkforce}
          location={selectLocation}
          setModalShow1={setModalShow1}
        />
        <ManageLocation
          show={modalShow}
          onHide={hideHandle}
          title={selectLocation ? "Edit Geography" : "Add Geography"}
          selectLocation={selectLocation}
          setModalShow={setModalShow}
        />
        <DeleteLocationPopup
          onHide={hideHandle}
          deleteRec={deleteRec}
          deleteModalShow={deleteModalShow}
          setDeleteModalShow={setDeleteModalShow}
        />
        <div className="d-flex justify-content-between mb-2">
          <h1 className="main-title">Manage Geography</h1>
          <div className="block1">
            <Button
              className="btn-primary border-0"
              href="#"
              style={{
                float: "right",
                boxShadow: "0px 4px 4px 0px rgba(133, 93, 217, 0.5)",
              }}
              onClick={() => addNewLocation()}
            >
              Add Geography
            </Button>
          </div>
        </div>
        <TableDesign
          className="mt-5 pt-4"
          {...{
            title: "List of All Geography",
            tableHeadings,
            filterHandler,
            filterOption,
            setFilterOption,
            isLoader,
          }}
        >
          {isLoader && <Loader />}
          {cc && cc.length ? (
            cc.map((row, i) => {
              if (row)
                return (
                  <tr key={i} className="align-items-center">
                    <td>{i + 1 + (page > 1 && (page - 1) * 10)}</td>

                    <td className="py-3">{row.name}</td>
                    <td className="py-3" style={{ whiteSpace: "normal" }}>
                      {row.email && row.email.length > 0
                        ? row.email.map((e, idx) => (
                            <span key={idx} className="d-block">
                              {e}
                            </span>
                          ))
                        : "-"}
                    </td>

                    <td className="py-3" style={{ whiteSpace: "normal" }}>
                      {row.ccEmail && row.ccEmail.length > 0
                        ? row.ccEmail.map((e, idx) => (
                            <span key={idx} className="d-block">
                              {e}
                            </span>
                          ))
                        : "-"}
                    </td>
                    <td className="py-3">{formatedDate(row.createdAt)}</td>

                    <td className="py-3">
                      <Dropdown align="end">
                        <Dropdown.Toggle>
                          <ThreeDotsVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {/* <Dropdown.Item
                            href=""
                            onClick={() => createUpdateWorkforce(row)}
                          >
                            Add Workforce
                          </Dropdown.Item> */}
                          <Dropdown.Item
                            href=""
                            onClick={() => createUpdateLocation(row)}
                          >
                            Edit
                          </Dropdown.Item>

                          <Dropdown.Item
                            href=""
                            onClick={() => deleteEventHandler(row)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                );
            })
          ) : (
            <>
              {!isLoader && (
                <tr>
                  <td colSpan="8">No Result Found</td>
                </tr>
              )}
            </>
          )}
        </TableDesign>
      </div>
      {/* <WorkForceListPage /> */}
      {(isRecordAdded || isRecordUpdated) && showResult && (
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded,
            isRecordUpdated,
            successMsg: message,
            title: title,
          }}
        />
      )}
    </>
  );
};

export default LocationList;
